import _ from "lodash";
import React, { useRef, useState } from "react";
import { importDevice } from "src/apis/CMS/device.api";
import { Notify } from "src/components/notify/Notify";
import * as XLSX from "xlsx";
import { convertExcelData, fileType, isInvalidFileData } from "./Helper";

const DeviceImport = ({ onUploadSuccess }) => {
  const [fileName, setFileName] = useState(null);
  const [excelFile, setExcelFile] = useState(null);
  const [excelFileError, setExcelFileError] = useState(null);

  const fileInputRef = useRef(null);
  const handleChangeFile = () => {
    fileInputRef.current?.click();
  };

  const handleFile = (e) => {
    fileInputRef.current?.setAttribute("value", "");

    let selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile && fileType.includes(selectedFile.type)) {
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = (e) => {
          setExcelFileError(null);
          setExcelFile(e.target.result);
          setFileName(selectedFile.name);
        };
      } else {
        setExcelFileError("Please select only excel file types");
        setExcelFile(null);
      }
    } else {
      console.log("plz select your file !!");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (excelFile !== null && !excelFileError) {
      const workbook = XLSX.read(excelFile, { type: "buffer" });
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];
      const data = XLSX.utils.sheet_to_json(worksheet, {
        blankrows: false,
        defval: "",
      });
      if (isInvalidFileData(data[0])) {
        let dataHandled = _.unionBy(
          [...convertExcelData(data)],
          (device) => device.ethMac
        );

        const filteredDevice = _.filter(dataHandled, function (o) {
          return o.ethMac !== "" && o.wifiMac !== "" && o.bluetoothMac !== "";
        });

        importDevice({ devices: filteredDevice }, (_) => {
          onUploadSuccess();
        });

        // updateLocalStorage(dataHandled);
        setExcelFile(null);
        setFileName(null);
      } else {
        Notify("warning", "Vui lòng chọn file device hợp lệ");
      }
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "end" }}>
      <input
        style={{ display: "none" }}
        type="file"
        className="form-control"
        onChange={handleFile}
        required
        placeholder="import file excel"
        ref={fileInputRef}
        onClick={(event) => {
          event.target.value = null;
        }}
      ></input>

      {fileName && (
        <p className="text-danger" style={{ marginTop: 20 + "px" }}>
          {fileName}
        </p>
      )}
      <button
        type="button"
        onClick={handleChangeFile}
        className="btn btn-success"
        style={{ marginTop: 5 + "px" }}
      >
        Import file
      </button>
      {excelFile !== null && (
        <button
          type="button"
          className="btn btn-success"
          style={{ marginTop: 5 + "px" }}
          onClick={handleSubmit}
        >
          Submit
        </button>
      )}
    </div>
  );
};

export default DeviceImport;
